import copyObject from "./component-library480.mjs";
import keysIn from "./component-library340.mjs";
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
export {
  toPlainObject as default
};
